import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'

import * as dimensionFilter from '../../../../dimension-filter'
import type { TypeParams } from '../../types'

/** Room Type dimension-filter plugin for the records collection. */
export class Plugin extends dimensionFilter.currentList.Plugin<
  TypeParams,
  typeof Plugin.id
> {
  /** @see {@link ec.plugins.Plugin.Id.Custom} */
  public static readonly id = ec.plugins.Plugin.Id.Custom.create(
    'RoomTypeDimensionFilter',
  )

  constructor({ collection }: Readonly<Plugin.constructor.Params>) {
    super({
      collection,
      currentListFilterKey: 'roomTypeFilter',
      dimensionId: ents.core.dms.models.Dimension.Id.from(
        ents.extra.quiver.resources.data.dimensions.roomTypes.RESOURCE.payload,
      ),
      id: Plugin.id,
    })
  }
}

export namespace Plugin {
  export namespace constructor {
    export interface Params {
      readonly collection: ec.Collection<TypeParams>
    }
  }
}
